// ============= Imports =============
import React from 'react';
import { Button, Spacer } from '@tw/tw-component-library';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import { AccountInfo } from '@azure/msal-browser';
import LogoImage from '../../../assets/Logo-Taylor Wessing_whitespace.png?url';
import {
  HeaderContainer,
  LayoutWrapper,
  LoginContainer,
  Logo,
  MainContent,
  WelcomeText,
} from './HeaderLayout.styles';

// ============= Types =============
interface HeaderLayoutProps {
  children: React.ReactNode;
  isAuthenticated: boolean;
  activeAccount: AccountInfo | null;
  login: () => Promise<void> | void;
  logout: () => Promise<void> | void;
}

// ============= Helper Functions =============
const formatUserName = (name: string): string => {
  return name.split(', ').reverse().join(' ');
};

// ============= Component =============
export const HeaderLayout: React.FC<HeaderLayoutProps> = ({
  children,
  activeAccount,
  login,
  logout,
}) => {
  const handleLogin = async () => {
    try {
      await login();
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <LayoutWrapper>
      <HeaderContainer>
        <Logo
          src={LogoImage}
          alt="Taylor Wessing Logo"
          width={200}
          height={50}
        />

        <AuthenticatedTemplate>
          <LoginContainer>
            <WelcomeText>
              Welcome,{' '}
              {activeAccount?.name
                ? formatUserName(activeAccount.name)
                : 'User'}
            </WelcomeText>
            <Spacer />
            <Button
              variant="block"
              onClick={handleLogout}
              aria-label="Logout from application"
            >
              Logout
            </Button>
          </LoginContainer>
        </AuthenticatedTemplate>

        <UnauthenticatedTemplate>
          <Button
            variant="block"
            onClick={handleLogin}
            aria-label="Login to application"
          >
            Login
          </Button>
        </UnauthenticatedTemplate>
      </HeaderContainer>

      <MainContent>{children}</MainContent>
    </LayoutWrapper>
  );
};

// ============= PropTypes =============
HeaderLayout.displayName = 'HeaderLayout';
